// src/components/Toolbar.jsx
import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../css/Toolbar.css';
import LogoutButton from './LogoutButton';
import api from '../utils/api';

import {
  HiHome,
  HiCpuChip,
  HiAdjustmentsVertical,
  HiQuestionMarkCircle,
} from "react-icons/hi2";

export default function Toolbar({
  transparent = false,
  decor = 'wave',
}) {
  const [dateStr, setDateStr] = useState("");
  const [timeStr, setTimeStr] = useState("");

  // 🔧 MotorGuard 스케줄러 상태
  const [guardEnabled, setGuardEnabled] = useState(false);
  const [guardLoading, setGuardLoading] = useState(false);
  const [guardError, setGuardError] = useState(null);

  // === 시계 ===
  useEffect(() => {
    const tick = () => {
      const now = new Date();

      const yyyy = now.getFullYear();
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const dd = String(now.getDate()).padStart(2, "0");
      setDateStr(`${yyyy}-${mm}-${dd}`);

      let h = now.getHours();
      const ampm = h >= 12 ? "오후" : "오전";
      h = h % 12 || 12;
      const hh = String(h).padStart(2, "0");
      const mi = String(now.getMinutes()).padStart(2, "0");
      const ss = String(now.getSeconds()).padStart(2, "0");
      setTimeStr(`${ampm} ${hh}:${mi}:${ss}`);
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  // === MotorGuard 초기 상태 조회 ===
  useEffect(() => {
    let cancelled = false;
    const fetchStatus = async () => {
      setGuardLoading(true);
      setGuardError(null);
      try {
        const res = await api.get("/status"); // GET /api/motor-guard/status
        if (!cancelled) {
          setGuardEnabled(!!res.data?.enabled);
        }
      } catch (e) {
        if (!cancelled) {
          setGuardError("자동 모터정지 상태 조회 실패");
        }
      } finally {
        if (!cancelled) setGuardLoading(false);
      }
    };
    fetchStatus();
    return () => {
      cancelled = true;
    };
  }, []);

  // === ON/OFF 토글 ===
  const handleToggleGuard = async () => {
    const next = !guardEnabled;
    setGuardLoading(true);
    setGuardError(null);
    try {
      if (next) {
        await api.post("/enable");   // POST /api/motor-guard/enable
      } else {
        await api.post("/disable");  // POST /api/motor-guard/disable
      }
      setGuardEnabled(next);
    } catch (e) {
      setGuardError("자동 모터정지 설정 변경 실패");
    } finally {
      setGuardLoading(false);
    }
  };

  const variantClass = transparent ? 'toolbar--transparent' : 'toolbar--solid';
  const decorClass = decor && decor !== 'none' ? `toolbar--decor-${decor}` : '';

  return (
    <header className={`toolbar ${variantClass} ${decorClass}`}>
      <nav className="toolbar__nav" aria-label="Global">

        {/* 좌측: 시계 */}
        <div className="toolbar-clock">
          <span className="clock-date">{dateStr}</span>
          <span className="clock-time">{timeStr}</span>
        </div>

        {/* 중앙 로고 */}
        <span className="toolbar-logo toolbar-logo--center" title="홈으로 이동">
          레이저 피난유도기 관제시스템
        </span>

        {/* 오른쪽 아이콘 & MotorGuard 토글 */}
        <div className="toolbar-right">
          {/* 🔴 자동 모터정지 토글 버튼 */}
          <button
            type="button"
            className={`toolbar-guard-toggle ${guardEnabled ? "on" : "off"}`}
            onClick={handleToggleGuard}
            disabled={guardLoading}
            title="motorflag=1일 때 자동으로 모터를 OFF합니다."
          >
            {guardLoading
              ? "적용 중..."
              : guardEnabled
                ? "자동 모터정지 ON"
                : "자동 모터정지 OFF"}
          </button>

          {/* 에러 메시지 (필요하면 CSS로 작게 표시) */}
          {guardError && (
            <span className="toolbar-guard-error">
              {guardError}
            </span>
          )}

          <ul className="toolbar-icon-menu">
            <li><NavLink to="/" title="홈"><HiHome /></NavLink></li>
            <li><NavLink to="/locations" title="장비관리"><HiCpuChip /></NavLink></li>
            <li><NavLink to="/user" title="운영관리"><HiAdjustmentsVertical /></NavLink></li>
            <li>
              <a href="/manuals/manual.pdf" target="_blank" rel="noopener noreferrer" title="도움말">
                <HiQuestionMarkCircle />
              </a>
            </li>
            <li><LogoutButton iconOnly /></li>
          </ul>
        </div>

      </nav>
    </header>
  );
}
